import { hanwahaInstance } from '../../shared_elements';

export const getRentalRateApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/rental-rates${queryString ? `?${queryString}` : ""}`;
};

export const getRentalRateListApi = (params, query) => {
    return `/rental-rates?lite=true`
}

export const getRentalRateDetailApi = (params) => {
    return `lease/${params?.leaseSlug}/rental-rates`;
};

export const addRentalRateApi = (params) => {
    return `lease/${params?.leaseSlug}/rental-rates`;
};

export const updateRentalRateApi = (params) => {
    return `lease/${params?.leaseSlug}/rental-rates/${params?.slug}`;
};

export const deleteRentalRateApi = (params) => {
    return `lease/${params?.leaseSlug}/rental-rates`;
};

export const exportRentalRateApi = (leaseId) => {
    return `lease/${leaseId}/rental-rates`;
};
export const getCurrencyApi = () => {
    return `/console/currency/`;
}


export const RentalRatefileUploadPostApi = (wrkgSlug, params) => {
    return `lease/rental_rates/${wrkgSlug}/attachments`;
};
 
export const getConsantApi = () => {
    return `lease/constants/get_by_constant_types`;
}

export const getMajorAssemblyApi = (params) => {
    return `console/${params?.leaseSlug}/major-assembly`;
}

export const fileImport = (params) => {
    return `parse-sample-excels/payment_schedule_sample`
}

export const sampleFile = () => {
    return `sample-excels/payment_schedule_sample`
}
export const customPaymentExport = (leaseSlug,slug) => {
    return `lease/${leaseSlug}/rental-rates/${slug}?export=true`
}

export const getInvoiceConfigApi = (params) => {
    return `lease/${params?.leaseSlug}/rental_rate/invoice-configuration`
}

export const UpdateInvoiceConfigApi = (params) => {
    return `lease/${params?.leaseSlug}/rental_rate/invoice-configuration`
}
 
export const getBankDropdown = (lessor_id, include_bank_id) => {
    let url = `api/dropdown/banks/?lessor_id=${lessor_id}`;
    if (include_bank_id) url += `&include_bank_id=${include_bank_id}`;
    return url;
}

export const getEscalationDetailsApi =(params, rentalSlug)=>{
    return `/lease/${params?.leaseSlug}/rental-rates/${rentalSlug}/escalation`
}

export const getProductServiceDropdownApi = (lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/products-services/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getChartOfAccountDropdownApi = (lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/chart-of-accounts/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getClassesDropdownApi = (lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/classes/?dropdown=true${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}

export const getSubClassesDropdownApi = (parent_class_id, lessor_name_id) => {
    const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';
    return `/integrations/${qbProvider}/classes/?dropdown=true${parent_class_id ? `&parent_class_id=${parent_class_id}` : ''}${lessor_name_id ? `&lessor_name_id=${lessor_name_id}` : ''}`;
}
